import React from "react";
import "./CoverScreen.css";

const CoverScreen = ({ onContinue }) => {
  return (
    <div className="cover-screen">
      <div className="cover-screen-content">
        <h1 className="cover-screen-title">Session Paused</h1>
        <p className="cover-screen-message">
          You’ve been inactive for a while. Please Click below to login again.
        </p>
        <button className="cover-screen-button" onClick={onContinue}>
          Continue...
        </button>
      </div>
    </div>
  );
};

export default CoverScreen;
